import { render, staticRenderFns } from "./Faecherliste.vue?vue&type=template&id=f8274b0e"
import script from "./Faecherliste.vue?vue&type=script&lang=js"
export * from "./Faecherliste.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports